import { SearchParamError } from './errors';

const SIGN_IN_PARAMS = ['state', 'session_state', 'iss', 'code', 'error'];

export function removeSignInParams(): void {
  const params = new URLSearchParams(globalThis.location.search);

  SIGN_IN_PARAMS.forEach((p) => {
    params.delete(p);
  });

  const queryStr = params.toString();

  globalThis.history.replaceState(
    null,
    '',
    `${globalThis.location.pathname}${queryStr ? `?${queryStr}` : ''}`,
  );
}

export function assertDefinedSearchParam(
  value: string | null,
  name: string,
): asserts value is string {
  if (!value) {
    throw new SearchParamError(name);
  }
}

export function isMinVersion(version: unknown, min: number): boolean {
  if (typeof version !== 'string') {
    return false;
  }

  const num = Number.parseInt(version);
  return !Number.isNaN(num) && num >= min;
}

export function prepareReport(message: string): string {
  return `<< THIS EMAIL IS A TEMPLATE >>
<< Please sign with your name and provide as much information as possible to help us debug the issue. >>

Hi,

I encountered the following error on Hibou:

  >> ${message}

Here is some additional context:

  - Browser: ${navigator.userAgent}
  - URL: ${globalThis.location.href}
  - << proposal, HDF5 file name, etc. >>

Thanks,
<< Name >>`;
}
